import React, { useMemo } from 'react';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from 'housecall-ui';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import useTheme from 'housecall-ui/dist/DesignSystem/Styles/useTheme';

import { useCustomTheme } from '../hooks/useCustomTheme';

type Props = {
  children: React.ReactNode;
};

const ThemeChanger = ({ children }: Props) => {
  const HCPTheme = useTheme();
  const { buttonColor, buttonTextColor, isPresent } = useCustomTheme();

  const customTheme = useMemo(
    () =>
      createTheme({
        ...HCPTheme,
        palette: {
          ...HCPTheme.palette,
          primary: {
            main: buttonColor || HCPTheme.palette.primary.main,
            contrastText: buttonTextColor || HCPTheme.palette.primary.contrastText,
          },
        },
      }),
    [HCPTheme, buttonColor, buttonTextColor]
  );

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!isPresent) return <>{children}</>;

  return <ThemeProvider theme={customTheme}>{children}</ThemeProvider>;
};

export const LeadFormThemeProvider = ({ children }: Props) => {
  return (
    <HousecallThemeProvider>
      <ThemeChanger>{children}</ThemeChanger>
    </HousecallThemeProvider>
  );
};
